<div class="border-box">
  <div class="flex items-center flex-col gap-[8px]">
    <img
      class="no-rooms-image"
      src="assets/img/reference-room-no-rooms.svg"
    />
  </div>

  <p>{{ '+INSTALLATIONS.INSTALLATION.REFERENCE_ROOM.ASSIGN_ROOM_DESCRIPTION' | translate }}</p>

  <button
    class="mt-[16px]"
    mat-stroked-button
    gtm="onSelect"
    gtmAction="Go to reference room management"
    gtmCategory="installationDetails"
    (click)="goToRoomManagement()"
  >
    {{ '+INSTALLATIONS.INSTALLATION.REFERENCE_ROOM.ASSIGN_ROOM_BTN' | translate }}
  </button>
</div>
